import { Card, CardContent } from '@/components/ui/card'
import { CodeBlock } from '../CodeBlock'
import { useTranslation } from '@/hooks/useTranslation'

export const StaticHtmlSection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="static-html" className="mb-16">
			<h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">
				{t('docs.staticHtml.title')}
			</h2>
			<Card className="shadow-sm dark:bg-gray-800/50">
				<CardContent className="pt-6">
					<p className="mb-4 text-gray-700 dark:text-gray-300">
						{t('docs.staticHtml.instruction.prefix')}{' '}
						<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
							&lt;/body&gt;
						</code>{' '}
						{t('docs.staticHtml.instruction.suffix')}
					</p>
					<CodeBlock
						language="html"
						copyLabel={t('docs.staticHtml.copyLabel')}
						copyMessage={t('docs.staticHtml.copyMessage')}
						code={`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>My Website</title>
</head>
<body>
    <h1>Welcome to my website!</h1>
    <p>Your content here...</p>
    
    <!-- Feedbask Widget -->
    <script
        defer
        src="https://cdn.feedbask.com/widget.js"
        data-client-key="YOUR_WIDGET_ID"
        data-language="en"
        id="feedbask-widget-script"
    ></script>
</body>
</html>`}
					/>
					<div className="mt-4 p-3 bg-green-50 dark:bg-green-900/20 rounded-md">
						<p className="text-sm text-green-800 dark:text-green-200">
							<strong>{t('docs.staticHtml.note.label')}</strong>{' '}
							{t('docs.staticHtml.note.text.prefix')}{' '}
							<code className="bg-green-100 dark:bg-green-800 px-1 py-0.5 rounded text-xs">
								YOUR_WIDGET_ID
							</code>{' '}
							{t('docs.staticHtml.note.text.suffix')}
						</p>
					</div>
				</CardContent>
			</Card>
		</section>
	)
}